<section class="ggc-toolbar-items" aria-label="kaart-tools">
  <div class="card card-tools">
    <div class="card-header">
      <div class="nav nav-tabs" role="tablist">
        <ng-content></ng-content>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="toolbarContentTemplate"></ng-container>
  </div>
</section>
